import React from 'react';
import { Typography } from 'src/components';

const FilterLabel = ({
  children,
  smallLabel = false,
}: {
  children: React.ReactNode;
  smallLabel?: boolean;
}) => {
  return (
    <Typography className={`self-stretch justify-start text-primary font-semibold font-['Inter'] leading-tight ${smallLabel ? 'text-xs' : 'text-sm'}`}>
      {children}
    </Typography>
  );
};

export default FilterLabel;
